<template>
    <button class="cookie" @click.prevent="showSettings = true" v-if="consentAnswered">
        <img src="../assets/images/cookies-icon.svg" alt="">
    </button>

    <div class="settings" v-if="showSettings" @click="closeSettings" ref="settings">
        <div class="panel">
            <h3>Gerir preferências de cookies</h3>
            <ul class="options">
                <li v-for="option, index in options" :key="index">
                    <label class="option">
                        <span v-text="option.text"></span>
                        <div class="switch">
                            <input type="checkbox" :checked="option.value" v-model="selected[option.name]" />
                            <span class="slider round"></span>
                        </div>
                    </label>
                </li>
            </ul>
            <div class="actions">
                <BetButton to="/" text="Rejeitar Todos" class="btn btn-reject" :action="setFalse">
                </BetButton>
                <BetButton to="/" text="Confirmar as minhas escolhas" class="btn btn-main" :action="saveConsent">
                </BetButton>
            </div>
        </div>
    </div>

    <div class="consent" v-if="!consentAnswered">
        <p>
            Utilizamos cookies para melhorar a tua experiência no nosso site. As cookies permitem-nos personalizar o
            conteúdo e anúncios, oferecer funcionalidades de redes sociais e analisar o nosso tráfego. Ao continuar a
            navegar no nosso site, concordas com a nossa política de cookies. Podes gerir as tuas preferências de
            cookies a qualquer momento.
        </p>
        <div class="actions">
            <BetButton text="Saiba Mais" class="btn"
                to="https://www.betano.pt/artigo/politica-de-privacidade/300141/#Paragraph11" :external="true">
            </BetButton>
            <BetButton to="/" text="Rejeitar" class="btn btn-reject" :action="setFalse"></BetButton>
            <BetButton to="/" text="Aceitar Todos" class="btn btn-main" :action="setTrue"></BetButton>
        </div>
    </div>
</template>

<script>
import BetButton from "./BetButton.vue"

export default {
    components: {
        BetButton,
    },
    data() {
        return {
            consentCookie: null,
            showSettings: false,
            selected: {
                functionality: false,
                essential: false,
                pub: false,
                analytics_storage: false,
                social: false,
                ad_storage: false,
                ad_personalization: false,
                geo: false,
                ad_user_data: false,
            },
        }
    },

    computed: {
        consentAnswered() {
            return this.consentCookie != null
        },
        functionalityConsent() {
            if (this.consentCookie == null) {
                return null
            }
            return this.consentCookie.functionality
        },
        options() {
            return [
                // {
                //     text: "Cookies funcionais",
                //     name: 'functionality',
                // },
                // {
                //     text: "Cookies essenciais",
                //     name: 'essential',
                // },
                // {
                //     text: "Cookies publicitárias",
                //     name: 'pub',
                // },
                {
                    text: "Cookies analíticas",
                    name: 'analytics_storage',
                },
                // {
                //     text: "Cookies das redes sociais",
                //     name: 'social',
                // },
                {
                    text: "Armazenar e/ou aceder a informações num dispositivo",
                    name: 'ad_storage',
                },
                {
                    text: "Publicidade e conteúdos personalizados, medição de publicidade e conteúdos, estudos de audiência e desenvolvimento de serviços",
                    name: 'ad_personalization',
                },
                // {
                //     text: "Utilizar dados de geolocalização precisos",
                //     name: 'geo',
                // },
                {
                    text: "Procurar ativamente as características do dispositivo para identificação",
                    name: 'ad_user_data',
                },
            ]
        },
    },

    methods: {
        gtagConsent() {
            let consent = {
                ad_storage: this.consentCookie.ad_storage ? 'granted' : 'denied',
                analytics_storage: this.consentCookie.analytics_storage ? 'granted' : 'denied',
                ad_user_data: this.consentCookie.ad_user_data ? 'granted' : 'denied',
                ad_personalization: this.consentCookie.ad_personalization ? 'granted' : 'denied',
            }
            this.$gtag.query('consent', 'update', consent);
        },
        closeSettings(e) {
            if (e.target == this.$refs.settings) {
                this.showSettings = false;
            }
        },
        saveConsent() {
            this.$cookies.set('consent', this.selected)
            this.consentCookie = this.$cookies.get('consent')
            this.showSettings = false
            this.gtagConsent()
        },
        setFalse() {
            for (let i in this.selected) {
                this.selected[i] = false
            }
            this.saveConsent()
        },
        setTrue() {
            for (let i in this.selected) {
                this.selected[i] = true
            }
            this.saveConsent()
        },
    },

    watch: {
        consentCookie: {
            immediate: true,
            handler() {
                if (this.consentCookie == null) {
                    return
                }
                this.selected = this.consentCookie
            },
        },
    },

    mounted() {
        this.consentCookie = this.$cookies.get('consent')
        let gtagDefault = {
            ad_storage: 'denied',
            analytics_storage: 'denied',
            ad_user_data: 'denied',
            ad_personalization: 'denied',
        }
        if (this.consentCookie != null) {
            gtagDefault.ad_storage = this.consentCookie.ad_storage ? 'granted' : 'denied'
            gtagDefault.analytics_storage = this.consentCookie.analytics_storage ? 'granted' : 'denied'
            gtagDefault.ad_user_data = this.consentCookie.ad_user_data ? 'granted' : 'denied'
            gtagDefault.ad_personalization = this.consentCookie.ad_personalization ? 'granted' : 'denied'
        } else {
            gtagDefault.wait_for_update = 400
        }
        this.$gtag.query('consent', 'default', gtagDefault);
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_colors.scss";
@import "@/assets/scss/queries";

@keyframes slide-in {
    0% {
        opacity: 0;
        transform: translateY(100%);
    }

    100% {
        opacity: 1;
    }
}

div.settings {
    position: fixed;
    z-index: 100002;
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    background-color: rgba(black, .7);

    .panel {
        // Position
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        margin: auto;
        max-height: 90%;
        max-width: 600px;
        height: fit-content;
        width: fit-content;

        // Colors
        background-color: rgba($color-background, .65);
        backdrop-filter: blur(20px);
        border-radius: 1rem 1rem 0 0;
        border: solid $color-betano;
        border-width: 2px 2px 0 2px;
        box-shadow: $color-betano 0px 0px 10px;

        // Sizing
        padding: 1rem;
        overflow: auto;

        .actions {
            display: flex;
            justify-content: space-around;
        }
    }

    .options {
        color: white;
        list-style: none;
        padding: 0;
        margin: 0;

        li {
            border: solid rgba(white, .5);
            border-width: 0 0 1px;

            &:last-child {
                border-width: 0;
            }
        }

        .option {
            padding: 1rem;
            display: flex;
            align-items: center;
            cursor: pointer;
            gap: 1rem;
        }

        .switch {
            position: relative;
            display: inline-block;
            width: 60px;
            height: 34px;
            margin: 0 0 0 auto;
            flex-shrink: 0;

            input {
                opacity: 0;
                width: 0;
                height: 0;

                &:checked+.slider {
                    background-color: $color-betano;

                    &:before {
                        -webkit-transform: translateX(26px);
                        -ms-transform: translateX(26px);
                        transform: translateX(26px);
                    }
                }

                &:focus+.slider {
                    box-shadow: 0 0 8px white;
                }
            }
        }

        .slider {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: #ccc;
            -webkit-transition: .4s;
            transition: .4s;
            border-radius: 34px;

            &::before {
                position: absolute;
                content: "";
                height: 26px;
                width: 26px;
                left: 4px;
                bottom: 4px;
                background-color: white;
                -webkit-transition: .4s;
                transition: .4s;
                border-radius: 50%;
            }
        }
    }
}

button.cookie {
    position: fixed;
    bottom: 1rem;
    left: 1rem;
    z-index: 100000;
    width: 40px;
    height: 40px;
    transition: .3s ease-out opacity;
    background: transparent;
    border: none;
    cursor: pointer;

    &:not(:hover) {
        opacity: 0.5;
    }

    img {
        width: 100%;
    }
}

div.consent {
    // Position
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 100000;

    //Size
    width: 1200px;
    max-width: 90%;
    padding: var(--menu-padding);

    // Colors
    background-color: rgba($color-background, .65);
    backdrop-filter: blur(20px);
    border-radius: 1rem 1rem 0 0;
    border: solid $color-betano;
    border-width: 2px 2px 0 2px;
    box-shadow: $color-betano 0px 0px 10px;

    // Animation
    animation: slide-in .65s ease-out;

    .actions {
        @include media(md, true) {
            flex-direction: column;
            gap: 1rem;
        }

        display: flex;
    }

    .btn {
        @include media(md, true) {
            width: 100%;
        }


        &:hover {
            background-color: transparent;
            transition-property: color, border-color;
        }

        &:not(&-main) {
            &:hover {
                border-color: white;
            }
        }

        &-reject {
            margin: 0 1rem 0 auto;
        }

        &-main {
            background-color: $color-betano;
            color: white;

            &:hover {
                background-color: rgba($color-betano, .65);
            }
        }
    }

}
</style>
